import {inject} from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig from "../../system/SystemConfig";
import IAudio from "../../engine/IAudio";
import System from "../../system/System";
import Wallet from "../../wallet/Wallet";
import VLT2DOM from "./VLT2DOM";
import events from "../../events/EventsObservable";
import {ACTION_EVENTS} from "../UserAction";
import IHwButtons from "../hwButtons/IHwButtons";
import IStatesManager from "../../states/IStatesManager";
import IGame from "../../game/IGame";
import DesktopUIController from "../desktop/DesktopUIController";

class VLT2UIController extends DesktopUIController {

    private hwButtons: IHwButtons;

    constructor(
        @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
        @inject(SERVICE_IDENTIFIER.DOM) dom: VLT2DOM,
        @inject(SERVICE_IDENTIFIER.StatesManager) statesManager: IStatesManager,
        @inject(SERVICE_IDENTIFIER.Game) game: IGame,
        @inject(SERVICE_IDENTIFIER.EngineAudio) audio: IAudio,
        @inject(SERVICE_IDENTIFIER.System) system: System,
        @inject(SERVICE_IDENTIFIER.Wallet) wallet: Wallet,
        @inject(SERVICE_IDENTIFIER.HwButtonsStates) hwButtons: IHwButtons
    ) {

        super(config, dom, statesManager, game, audio, system, wallet);

        this.hwButtons = hwButtons;
    }

	protected _infoOpen() {}

	initHomeButton() {
        events.subscribe(ACTION_EVENTS.ACTION_HOME_BUTTON, async () => {

            try {
                await this.hwButtons.turnOff()
            } catch(e) {
                throw e;
            } finally {
                history.back();
            }
            return;

        });
    }
}

export default VLT2UIController;
